import Forum from '@mui/icons-material/Forum';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function ForumIcon(props: FixMe) {
  return <Forum {...props} />;
}

export default ForumIcon;
